import { render, staticRenderFns } from "./StudentEducationBKFEducationRow.vue?vue&type=template&id=1fe29bac&scoped=true&"
import script from "./StudentEducationBKFEducationRow.vue?vue&type=script&lang=ts&"
export * from "./StudentEducationBKFEducationRow.vue?vue&type=script&lang=ts&"
import style0 from "./StudentEducationBKFEducationRow.vue?vue&type=style&index=0&id=1fe29bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe29bac",
  null
  
)

export default component.exports